import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Form, Input, Label, Row } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"


const columns = [
    {
        label: "Realizado por",
        field: "colaborador_que_asigna_nombre",
        sort: "asc"
    },
    {
        label: "Articulo",
        field: "articulo_nombre",
        sort: "asc"
    },
    {
        label: "Asignado a",
        field: "colaborador_que_recibe_nombre",
        sort: "asc"
    },
    {
        label: "Movimiento",
        field: "comentario",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado_nombre",
        sort: "asc"
    },
    {
        label: "Fecha de Registro",
        field: "fecha_registro_str",
        sort: "asc"
    }
];

export default class ReporteHistorialArticuloAsignado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        props = _valid(props, props.props) ? props.props : props;
        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
            },
            //data a mostrar
            tabla: { columns: columns, rows: [] },
            departamentoAreas: [],
            articulosLista: [],
            colaboradoresLista: [],
            consulta: {
                fechaFin: null,
                fechaMin: null,
                asignado: null,
                articulo: null
            },
            timeralert: null,
        };
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
    }

    componentDidMount() {
        this.obtenerArticulos();
        this.obtenerColaboradores();
    }

    obtenerArticulos() {
        if(this.apiRest.getRol()){
            this.apiRest.get('/articulo').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ articulosLista: this.articuloSelect(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }else{
            if(this.apiRest.getLS('idEmpresa')){
                this.apiRest.getArticuloEmpresa('/getArticuloEmpresa/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ articulosLista: this.articuloSelect(respuesta) });
                    }
                });
            }
        }
    }
    
    obtenerColaboradores() {
        if(this.apiRest.getRol()){
            this.apiRest.get('/colaborador').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ colaboradoresLista: this.formatoSelect(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }else{
            if(this.apiRest.getLS('idEmpresa')){
                this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ colaboradoresLista: this.formatoSelect(respuesta) });
                    }
                });
            }
        }
    }

    //formato a valores de area
    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombres+" "+i.apellidos }));

    articuloSelect = valores => valores.data.map(i => ({ value: i.id, label: i.codigo+" "+i.nombre+" "+i.serie+" "+i.marca }));

    //set nombre area
    setArea = asignado => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['asignado']: asignado }
        }));
    }

    setArticulo = articulo => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['articulo']: articulo }
        }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, [name]: value }
        }));
    }

    buscar = async () => {
        const {
            consulta
        } = this.state

        if (this.verificar(consulta)) {
            this.apiRest.put('/reporteHistorialArticuloAsignado', consulta).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tabla: {columns, rows: resultado.data } })
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    verificar = (data) => {
        let contador = 0;
        let estado = true;
        if (_valid(data.fechaMin)) {
            if (_valid(data.fechaFin)) {
                contador += 1;
            }else{
                estado = false;
                toastr.error('Seleccione fecha de fin por favor');
            }
        }
        if (_valid(data.fechaFin)) {
            if (_valid(data.fechaMin)) {
                contador += 1;
            }else{
                estado = false;
                toastr.error('Seleccione fecha de inicio por favor');
            }
        }

        if (_valid(data.asignado)) {
            contador += 1;
        } 
        if (_valid(data.articulo)) {
            contador += 1;
        }

        if (contador !== 0) {
            return true;
        } else {
           if(estado){
                toastr.error('Seleccione un filtro');
            }
            return false;
        }
    }

    render() {
        const {
            articulosLista,
            colaboradoresLista,
            consulta
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        {this.state.timeralert}
                        <Breadcrumbs title="Activos" breadcrumbItem={"Trazabilidad de Activos"} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={4}>
                                                <Label htmlFor="asignado" className="form-label">
                                                    Asignado a
                                                </Label>
                                                <Select
                                                    name="asignado"
                                                    options={colaboradoresLista}
                                                    value={consulta.asignado}
                                                    onChange={this.setArea}
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Label htmlFor="articulo" className="form-label">
                                                    Articulo
                                                </Label>
                                                <Select
                                                    name="articulo"
                                                    options={articulosLista}
                                                    value={consulta.articulo}
                                                    onChange={this.setArticulo}
                                                />
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col lg={4}>
                                                <Label htmlFor="fechaMin" className="form-label">
                                                    Fecha inicial
                                                </Label>
                                                <Input
                                                    value={consulta.fechaMin}
                                                    onChange={this.actualizarValores}
                                                    name="fechaMin"
                                                    type="date"
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Label htmlFor="fechaFin" className="form-label">
                                                    Fecha fin
                                                </Label>
                                                <Input
                                                    value={consulta.fechaFin}
                                                    onChange={this.actualizarValores}
                                                    name="fechaFin"
                                                    type="date"
                                                />
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col lg={3}>
                                                <MDBBtn className="waves-effect" color="primary" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <br />
                                        <div className="p-4 border-top">
                                            <Form>
                                                <Row>
                                                    <Col lg={12}>                                                            
                                                        <div className="table-responsive">
                                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}